import Vue from 'vue'
import Vuex from 'vuex'
import cloneDeep from 'lodash/cloneDeep'
import user from './modules/user'
import punchout from './modules/punchout'
import ecology from './modules/ecology'
import app from './modules/app'
import unsentChatData from './modules/unsentChatData'
import { getAccessToken } from '@/utils/userInfo'

Vue.use(Vuex)

export default new Vuex.Store({
  namespaced: true,
  state: {
    // 导航条, 布局风格, defalut(白色) / colorful(鲜艳)
    navbarLayoutType: 'colorful',
    // 侧边栏, 布局皮肤, default(白色) / dark(黑色)
    sidebarLayoutSkin: 'dark',
    // 侧边栏, 折叠状态
    sidebarFold: false,
    // 侧边栏, 菜单
    sidebarMenuList: [],
    sidebarMenuActiveName: '',
    // 内容, 是否需要刷新
    contentIsNeedRefresh: false,
    // 卡片列表
    cardInfo: [],
    // 内容, 标签页(默认添加首页)
    contentTabs: [
      {
        ...window.SITE_CONFIG['contentTabDefault'],
        'name': 'home',
        'title': 'home'
      }
    ],
    contentTabsActiveName: 'home',
    refresh: true,
    // 菜单列表
    menuList: [],
    categoryMenuList: [], // 商品类目列表
    loadStatus: false,
    shoppingCartCount: -1,
    // 联储联备领用list
    lclbDataList: [],
    requirementGoodsList: [] // 备件需求List

  },
  modules: {
    user,
    punchout,
    ecology,
    unsentChatData,
    app
  },
  mutations: {
    resetRefresh (state, data) {
      state.refresh = data
    },
    // 重置vuex本地储存状态
    resetStore (state) {
      Object.keys(state).forEach((key) => {
        state[key] = cloneDeep(window.SITE_CONFIG['storeState'][key])
      })
    },
    setMenuList (state, menuList) {
      state.menuList = menuList
    },
    setCategoryMenuList (state, categoryMenuList) {
      state.categoryMenuList = categoryMenuList
    },
    setLoadStatus (state, loadStatus) {
      state.loadStatus = loadStatus
    },
    setShoppingCartCount (state, shoppingCartCount) {
      state.shoppingCartCount = shoppingCartCount
    },
    setLclbDataList (state, list) {
      state.lclbDataList = list
    },
    setrequirementGoodsList (state, list) {
      state.requirementGoodsList = list
    }
  },
  actions: {
    setShoppingCartCount ({ state, commit }, shoppingCartCount) {
      commit('setShoppingCartCount', shoppingCartCount)
    },
    setLclbDataList ({ state, commit }, list) {
      commit('setLclbDataList', list)
    },
    setrequirementGoodsList ({ state, commit }, list) {
      commit('setrequirementGoodsList', list)
    }
  },
  getters: {
    getToken () {
      let token = getAccessToken()
      let result = ''
      if (token && token !== 'null' && token !== 'undefind') {
        result = token
      }
      return result
    }
  }
})
